import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { Col, Form, Row, Button } from "react-bootstrap";
import InputMask from "react-input-mask";
import { getEntrepreneur, updateEntrepreneur } from "../../services/api";
import { UpdateEntrepreneurSchema } from "../../utils/validation_schemas";
import LoadingIndicator from "../LoadingIndicator";
import SuccessAlert from "../SuccessAlert";
import ErrorAlert from "../ErrorAlert";
import handleChangeCep from '../../utils/validate_cep'
import useNotification from "../../contexts/notification";
import getState, { statesList,statesMap } from "../../utils/uf";
import {getCidades} from "../../services/api"
export default function UpdateEntrepreneurForm({ paymentsMethod, entrepreneurId, onLoaded, onDone }) {
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState({ status: "start" });
  const clearStatus = () => setStatus({ status: "start" });
  const { setMessage } = useNotification();
  const [cities, setCities] = useState([]);
  const formik = useFormik({
    initialValues: {
      type: "poster",
      name: "",
    
      telephone: "",
      email: "",
      
      city: "",
      password: "",
      show_password: false,
    },
    validationSchema: UpdateEntrepreneurSchema,
    onSubmit: async (values) => {
      const entrepreneur = {
        ...values,
        type: "poster",
      };

      if (entrepreneur.password.length === 0) {
        delete entrepreneur.password;
      }

     

      const updated = await updateEntrepreneur(entrepreneur);
      onDone?.();

      setStatus(updated ? { status: "success" } : { status: "error" });
    },
  });
  useEffect(() => {
    async function getCities() {
      
      const uf = getState(formik.values.state);

      const cities =  await getCidades(uf);
      
      setCities(cities)
    }

    if(formik.values.state) {
      getCities()
    }

  },[formik.values.state])
  useEffect(() => {
    getEntrepreneur(entrepreneurId).then(
      (data) => {
        const [entrepreneur] = data;
       
        formik.setValues({
          id: entrepreneur.id,
          
          
          type: "poster",
          name: entrepreneur.name,
          
          telephone: entrepreneur.telephone,
          email: entrepreneur.email,
          
          city: entrepreneur.city ? entrepreneur.city.name : '',
          state: entrepreneur.city ? statesMap[entrepreneur.city.uf] : '',
          password: "",
          show_password: false,
        });

        setLoading(false);
        if (onLoaded) {
          onLoaded();
        }
      },
      () =>
        setMessage({
          error: true,
          content: "Ocorreu um erro. Tente novamente mais tarde",
        })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entrepreneurId]);

  if (loading) {
    return <LoadingIndicator />;
  }

  return (
    <Form noValidate onSubmit={formik.handleSubmit} className="pt-2">
      <h6 className="mb-3 text-primary">Dados do Postador</h6>
      <Form.Group as={Row}>
        <Col lg={8}>
          <Form.Label>Nome Completo *</Form.Label>
          <Form.Control
            type="text"
            name="name"
            placeholder="Nome Completo"
            onChange={formik.handleChange}
            value={formik.values.name}
            isValid={
              formik.touched.name &&
              !formik.errors.name
            }
            isInvalid={formik.errors.name}
          />
          <Form.Control.Feedback tooltip type="invalid">
            {formik.errors.name}
          </Form.Control.Feedback>
        </Col>
       
       
        <Col lg={4}>
          <Form.Label>Telefone *</Form.Label>
          <Form.Control
            type="text"
            name="telephone"
            placeholder="Telefone"
            as={InputMask}
            mask="(99)99999-9999"
            onChange={formik.handleChange}
            value={formik.values.telephone}
            isValid={formik.touched.telephone && !formik.errors.telephone}
            isInvalid={formik.errors.telephone}
          />
          <Form.Control.Feedback tooltip type="invalid">
            {formik.errors.telephone}
          </Form.Control.Feedback>
        </Col>
        <Col xl={8}>
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="email"
            name="email"
            placeholder="Seu email"
            onChange={formik.handleChange}
            value={formik.values.email}
            isValid={formik.touched.email && !formik.errors.email}
            isInvalid={formik.errors.email}
          />
          <Form.Control.Feedback tooltip type="invalid">
            {formik.errors.email}
          </Form.Control.Feedback>
        </Col>
      </Form.Group>
     
      
      
      <h6 className="mb-3 text-primary">Endereço</h6>
      <Form.Group>
            <Row className="align-items-center">
              
              <Col sm={12} md={4} xl={4}>
              <Form.Label>Estado *</Form.Label>
                <Form.Control
                  required
                  as="select"
                  name="state"
                  onChange={formik.handleChange}
                  value={formik.values.state}
                  autoComplete="off"
                  
                  custom
                  isInvalid={ formik.errors.state && formik.touched.state }
                  defaultValue=""
                >
                  <option disabled value=""> Selecione </option>
                  {statesList.map((state) => (
                    <option key={state.id} value={state.name}>
                      {state.name}
                    </option>
                  ))}
                </Form.Control>
                <Form.Control.Feedback tooltip type="invalid">
                  {formik.errors.state}
                </Form.Control.Feedback>
                </Col>
              <Col sm={12} md={4} xl={4}>
                <Form.Label>Cidade *</Form.Label>
                <Form.Control
                  required
                  as="select"
                  name="city"
                  onChange={formik.handleChange}
                  value={formik.values.city}
                  autoComplete="off"
                 
                  custom
                  isInvalid={ formik.errors.city && formik.touched.city }
                  defaultValue=""
                >
                  <option disabled  value=""> Selecione </option>
                  {cities.map((c) => (
                    <option key={c.id} value={c.name}>
                      {c.name}
                    </option>
                  ))}
                </Form.Control>
                 <Form.Control.Feedback tooltip type="invalid">
                  {formik.errors.city}
                </Form.Control.Feedback>
              </Col>
            </Row>
          </Form.Group>
      <h6 className="mb-3 text-primary">Senha</h6>
      <Form.Group as={Row}>
        <Col lg={6}>
          <Form.Label>Nova senha</Form.Label>
          <Form.Control
            type={formik.values.show_password ? "text" : "password"}
            name="password"
            placeholder="Nova senha"
            onChange={formik.handleChange}
            value={formik.values.password}
            isValid={formik.touched.password && !formik.errors.password}
            isInvalid={formik.errors.password}
          />
          <Form.Text className="text-muted">
            A senha deve ter no mínimo 8 caracteres entre números e letras.
          </Form.Text>
          <Form.Control.Feedback tooltip type="invalid">
            {formik.errors.password}
          </Form.Control.Feedback>
          <Form.Check
            id="show-password-3"
            name="show_password"
            className="mb-2"
            type="switch"
            label="Mostrar senha"
            onChange={formik.handleChange}
            checked={formik.values.show_password}
            custom
          />
        </Col>
      </Form.Group>
      {status.status === "success" && (
        <SuccessAlert msg="Perfil atualizado com sucesso." onClose={clearStatus} />
      )}
      {status.status === "error" && (
        <ErrorAlert msg="Ocorreu um erro, por favor tente novamente mais tarde." onClose={clearStatus} />
      )}
      <Form.Group as={Row}>
        <Col xs="auto">
          <Button variant="primary" type="submit">
            Atualizar
          </Button>
        </Col>
      </Form.Group>
    </Form>
  );
}
